import { render, staticRenderFns } from "./ChatManagement.vue?vue&type=template&id=1e0343e4&scoped=true"
import script from "./ChatManagement.vue?vue&type=script&lang=js"
export * from "./ChatManagement.vue?vue&type=script&lang=js"
import style0 from "./ChatManagement.vue?vue&type=style&index=0&id=1e0343e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0343e4",
  null
  
)

export default component.exports